import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  && {\n    background: ", ";\n    color: ", ";\n    text-align: ", ";\n\n    a[href] {\n      ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    html, body {\n        background: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { palette } from '../varnish/palette';
import Link from '../link';
import Layout from '../layout';
var AppLayoutContext = Layout.AppLayoutContext;

var Footer =
/** @class */
function () {
  var Footer = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(Footer, _React$PureComponent);

    var _super = _createSuper(Footer);

    function Footer() {
      _classCallCheck(this, Footer);

      return _super.apply(this, arguments);
    }

    _createClass(Footer, [{
      key: "render",
      value: function render() {
        var _this = this;

        var contrast = this.props.variant === 'dark' ? true : undefined;
        return /*#__PURE__*/React.createElement(AppLayoutContext.Consumer, null, function (_ref) {
          var appLayoutVariant = _ref.appLayoutVariant;
          return /*#__PURE__*/React.createElement(StyledFooter, {
            contrast: contrast,
            layout: appLayoutVariant,
            className: _this.props.className
          }, _this.props.setPageBackground ? /*#__PURE__*/React.createElement(WithPageBackground, {
            color: contrast ? palette.background.dark : palette.background.light
          }) : null, _this.props.children ? _this.props.children : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
            href: "https://allenai.org"
          }, "\xA9 The Allen Institute for Artificial Intelligence"), ' ', "- All Rights Reserved |", ' ', /*#__PURE__*/React.createElement("a", {
            href: "https://allenai.org/privacy-policy.html"
          }, "Privacy Policy"), " |", ' ', /*#__PURE__*/React.createElement("a", {
            href: "https://allenai.org/terms.html"
          }, "Terms of Use")));
        });
      }
    }]);

    return Footer;
  }(React.PureComponent);

  Footer.defaultProps = {
    setPageBackground: true
  };
  return Footer;
}();

export default Footer;
var WithPageBackground = createGlobalStyle(_templateObject(), function (_ref2) {
  var color = _ref2.color;
  return "".concat(color);
});
var StyledFooter = styled(Layout.Footer)(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme,
      contrast = _ref3.contrast;
  return contrast ? theme.palette.background.dark : theme.palette.background.light;
}, function (_ref4) {
  var theme = _ref4.theme,
      contrast = _ref4.contrast;
  return contrast ? theme.palette.text.contrast : theme.palette.text["default"];
}, function (_ref5) {
  var layout = _ref5.layout;
  return layout !== 'app' ? 'center' : null;
}, function (_ref6) {
  var contrast = _ref6.contrast;
  return contrast ? Link.contrastLinkColorStyles() : null;
});